
<div>
  <b-navbar ref="nav" aria-controls="disabled" toggleable="lg" type="dark" class="nav no-key-nav">
    <b-navbar-brand @click="openTextView" to="#">STTylus</b-navbar-brand>
    <b-navbar-brand v-if="user_name">
      <small>Inloggad som: {{ user_name }}</small>
    </b-navbar-brand>

    <b-navbar-toggle target="nav-collapse" />

    <b-collapse id="nav-collapse" is-nav>
      <!-- <b-navbar-nav>
        <b-nav-item to="/news">Nyheter</b-nav-item>
      </b-navbar-nav>
      -->
      <!-- Right aligned nav items -->

      <b-navbar-nav class="ml-auto nav-fill sttylus-nav">
        <b-nav-item v-show="notLogin" @click="showSupport">Stödtolkning <kbd>F1</kbd></b-nav-item>
        <b-nav-item v-show="notLogin" no-key-nav @click="addAbb('')">
          Skapa förkortning <kbd>F2</kbd>
        </b-nav-item>
        <b-nav-item v-if="!desktop" v-show="textViewOnly" @click="showRemoteSettings">Distanstolkning <kbd>F9</kbd></b-nav-item>
       <b-nav-item v-show="inSession && textViewOnly" to="#" @click="toggleChat()">
          <b-badge>
            <span v-if="connectedClients == 0">Ingen </span>
            <span v-else>
              {{ connectedClients }}
            </span>
            <span v-if="connectedClients > 1">anslutna</span>
            <span v-else>ansluten</span>
          </b-badge>
           <kbd>F10</kbd>
        </b-nav-item>

        <b-nav-item v-if="desktop" v-show="notLogin" @click="showLocalSettings">Lokal tolkning</b-nav-item>
        <b-nav-item v-show="textViewOnly" @click="openSettings">Inställningar <kbd>F5</kbd></b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
  <Support @addAbb="addAbb" :view="view" />
  <RemoteInterpretation />
  <LocalInterpretation />
</div>
